export default __webpack_public_path__ + "static/Image-New-Plan-for-Rhode-Island-59f3fb4cb1e5e03830b059c76b6d954d.jpg";